export const REFRESH_TOKEN = 'contacts/refresh';
export const USER = '/user/';
export const USERS = '/users/';
export const AUTH = `${USER}auth/`;

const ORGANIZATIONS = '/organizations';
const PLAN_YEARS = '/plan-years';
const CLAIMS = '/claims';
const CARRIERS = '/carriers';
const CARRIER_CONFIGS = '/carrier-configs';
const PLANS = '/plans';
const HEALTH_PLANS = '/health-plans';
const ENUM = '/enums';
const FILES = '/files';
const EMPLOYEES = '/employees';
const CONTACTS = '/contacts';
const CARD_HOLDERS = '/card-holders';
const UI = '/ui';
const FILE = '/file';
const EXPRESS_SETUPS = '/express-setups';
const SERVICES = '/services';
const CATEGORIES = '/categories';
const CARD_PURSES = '/card-purses';
const SPEND_LIMIT_PERIODS = '/spend-limit-periods';
const RENEWALS = '/renewals';

const INTEREST_RATE = '/interest-rate-templates';
const PRIORS = '/priors';
const PAYOUT_DEFINITION = '/payout-definitions';
const TEMPLATES = '/templates';
const LINKED_TEMPLATES = '/linked-templates';
const IDOLOGY_PREFIX = '/idology';
const DEPENDENTS_V2 = `/v2/dependents`;
const UPLOAD_EXCESS_CONTRIBUTION_FILE = `/tax-forms/excess-contributions/file-upload`;
/**
 * @deprecated Use `import {API_URL} from '@/dtos'` instead. This will be removed soon.
 */
export default {
  ADD_VAULTED_ACCOUNT_TO_RECIPIENT: (merchantCustomerId?: string) =>
    `/recipients/${merchantCustomerId}/accounts`,
  ACCOUNT_ACTIVITIES_BY_ID: (accountId: string) => `/v2/activities/accounts/${accountId}`,
  GET_TRANSACTION_TYPES_BY_ACCOUNT_ID: (accountId?: string) =>
    `/activities/accounts/${accountId}/transaction-types`,

  GET_AUDIT_CONTRIBUTION_CHANGESETS: (requestId?: string) =>
    `/audit/contribution-requests/${requestId}/changesets`,
  GET_AUDIT_CHANGESET_ATTRIBUTES: (changesetId?: string) => `/audit/changesets/${changesetId}/attributes`,
  SEARCH_AUDIT_CHANGESET_CHANGES: (changesetId?: string) => `/audit/changesets/${changesetId}/search`,
  ACCOUNT_MANAGERS: '/account-managers',
  ACCOUNT_TYPES: `${ENUM}/account-types`,
  ACCOUNT_TOKEN: '/account-tokens',
  GET_ACCOUNT_ORDERS: '/account-orders',
  CHECK_FORFEITED_ACCOUNT_ORDERS: '/postings/account/amount',
  ACTIVITY_CLAIMS_BY_ID: (claimId: string) => `/activities/claims/${claimId}`,
  ACTIVITY_POSTINGS_BY_ID: (postingId: string) => `/activities/postings/${postingId}`,
  ADD_EMPLOYEE: `${UI}/employees`,
  ADD_PROVIDER: '/providers',
  ADD_CARRIER: CARRIERS,
  ACCOUNT_CLOSE: '/accounts/close',
  ADD_CARRIER_CONFIG: CARRIER_CONFIGS,
  UPDATE_PROVIDER: (id?: string) => `/providers/${id}`,
  BANK_ACCOUNT_CATEGORIES: `${ENUM}/account-categories`,
  BANK_INFORMATION_BY_ID: (id: string) => `${ORGANIZATIONS}/${id}/accounts`,
  BANK_INFORMATION: '/accounts',
  BANC_ACCOUNT_BY_ID: (accountId: string | number) => `/accounts/${accountId}`,
  DECRYPTED_BANC_ACCOUNT_BY_ID: (accountId: string | number) => `/accounts/${accountId}/number/decrypted`,
  BANK_METHODS: `${ENUM}/bank-methods`,
  BUSINESS_ENTITY_TYPES: `${ENUM}/business-entity-types`,
  CIP_STATUS: '/cip-statuses',
  CIP_COMPLETE_VERIFICATION: '/complete-cip-verification',
  CIP_INFO: '/cip-infos/employee-id',
  CIP_IDENTIFICATION: `${IDOLOGY_PREFIX}/identification`,
  CARD_ADD_DEPENDENT: '/card-add-dependent',
  CARD_HOLDER_MOCK: '/card-holder',
  CARD_HOLDERS_MOCK: CARD_HOLDERS,
  CARD_HOLDERS: (query: string) => `${CARD_HOLDERS}?${query}`,

  CARD_TRANSACTIONS: '/transaction/card/',
  CARDS: '/cards',
  CARD_PURSES,
  GET_CARRIERS: CARRIERS,
  GET_IRS_LIMITS: '/contribution-requests/irs-limits/search',
  CHANGE_CONTRIBUTION_REQUEST_STATUS: (contributionId?: string, status?: string) =>
    `/contributions/contribution-requests/${contributionId}/status?status=${status}`,
  GET_PERMISSIONS: '/permissions',
  GET_CARRIER_BY_ID: (id?: string) => `${CARRIERS}/${id}`,
  GET_CARRIER_CONFIGS: CARRIER_CONFIGS,
  GET_CARRIER_CONFIG: (id: string) => `${CARRIER_CONFIGS}/${id}`,
  GET_ORGANIZATIONS_HIERARCHY: `${ORGANIZATIONS}/hierarchy`,
  GET_CHECKS_LIST: '/checks/search',
  GET_OVERRIDABLE_PROPERTIES_FIELD_STATE: `${ENUM}/overridable-properties-field-state`,
  GET_ALREADY_EXIST_CLAIMS_TEAMS: '/claims-teams/search-assigned',
  VOID_CHECK: (id?: string) => `/checks/${id}/void`,
  REISSUE_CHECK: (id?: string) => `/checks/${id}/reissue`,
  DISABLE_CARRIER_CONFIG: (id: string) => `${CARRIER_CONFIGS}/disable/${id}`,
  LINK_ACCOUNT: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/link`,
  PROCESS_CLAIM: (id?: string) => `${CLAIMS}/${id}/process`,
  CLOCK_IN: (id?: string, clockIn?: boolean) => `${CONTACTS}/${id}/clock-in?clockIn=${clockIn}`,
  CHECK_ACCOUNT_NUMBER: '/check-account-number',
  CHECK_ROUTING_NUMBER: '/check-routing-number',
  CHECK_WRITINGS: `${ENUM}/check-writings`,
  CARD_SHIPMENT_BY_ID: (id: string) => `/cards/${id}/shipment-events`,
  CLAIM_DETAILS_BY_ID: (claimId?: string) => `${CLAIMS}/${claimId}`,
  CLAIM_STATUSES: `${ENUM}/claim-status`,
  CLAIMS_PAYMENT_DETAILS: `${CLAIMS}/payment-details`,
  CLAIMS: `${CLAIMS}/search`,
  COMMUNICATIONS: '/communications',
  COMMUNICATIONS_RESEND: (id: string) => `/communications/${id}/resend`,
  CLAIMS_TEAMS: '/claims-teams',
  CLAIMS_TEAM: (id?: string) => `/claims-teams/${id}`,
  CLAIMS_TEAM_HIERARCHY: (id?: string) => `/organizations/claims-team/${id}/hierarchy`,
  CLAIMS_PROCESSOR: (id?: string) => `/claims-processor/${id}`,
  ASSIGN_TEAMS_TO_CLAIMS_PROCESSOR: (id?: string) => `${CONTACTS}/${id}/claims-teams`,
  ASSIGN_PROCESSORS_TO_TEAM: (id?: string) => `/claims-teams/${id}/contacts`,
  ASSIGN_CLAIMS_TO_PROCESSOR: `${CLAIMS}/assign-contact`,
  UNASSIGN_CLAIMS_TO_PROCESSOR: `${CLAIMS}/unassign-contact`,
  CLAIM_CONFIG_UPDATE: (employeeId: string) => `/employees/${employeeId}/claim-config`,
  CREATE_CLAIM: CLAIMS,
  COVERAGES: '/coverages',
  CONTACTS,
  CONTACTS_COUNT_BY_ROLE: '/contacts/count-by-role',
  CONTACT_INFO: (contactId?: string) => `${CONTACTS}/${contactId}`,
  TRANSFER_ACCOUNTS: (claimId?: string) => `/transfer/claims/${claimId}/accounts`,
  CONTACTS_LIST: `${CONTACTS}/all`,
  CONTACTS_TEAMS: `${CONTACTS}/teams`,
  UPDATE_CONTACT: (contactId?: string) => `${CONTACTS}/${contactId}`,

  COPAY_GROUPS: '/copay-groups',
  COPAY_GROUPS_BY_ID: (id?: string) => `/copay-groups/${id || ''}`,
  CREATE_INTERNAL_NOTE: `${CLAIMS}/internal-notes`,
  CREATE_DOCUMENT_ID: '/documents',
  DEDUCTIBLES_SERVICES: '/deductibles-services',
  DEDUCTIBLE_PREVIEW: (id?: string) => `/deductibles/employees/${id}/preview`,
  DEDUCTIBLES: '/tiers/deductibles',
  UPDATE_DEDUCTIBLES_BY_ID: (id?: string) => `/deductibles/employees/${id}`,
  CREATE_EXCESS_CONTRIBUTION: '/tax-forms/excess-contributions',
  UPLOAD_EXCESS_CONTRIBUTION_FILE,
  GET_EXCESS_CONTRIBUTION_BY_ID: (id?: string) => `/tax-forms/excess-contributions/${id}`,

  GET_INDIVIDUAL_DEDUCTIBLES_TIERS: (employeeId?: string) =>
    `/deductibles/available-tiers/individual/${employeeId}`,
  GET_FAMILY_DEDUCTIBLES_TIERS: (employeeId?: string) => `/deductibles/available-tiers/family/${employeeId}`,
  UPDATE_DEDUCTIBLE_TIER: (id?: string) => `/deductibles/tiers/${id}`,
  DEACTIVATE_CONTACT: (id: string) => `${CONTACTS}/${id}/statuses/DISABLED`,
  DEACTIVATE_ORGANIZATION: (id: string) => `${ORGANIZATIONS}/${id}/statuses/TERMINATED`,
  ACTIVATE_ORGANIZATION: (id: string) => `${ORGANIZATIONS}/${id}/activate`,
  TERMINATE_ORGANIZATION: (id: string) => `${ORGANIZATIONS}/${id}/termination`,
  TERMINATE_PLAN: `${PLANS}/termination-properties`,
  GET_PLAN_TERMINATION_PROPERTIES: (id?: string) => `${PLANS}/${id}/termination-properties`,
  DELETE_DOCUMENT: (id: string) => `/documents/${id}`,
  DELETE_FILE: (id: string) => `/documents/files/${id}`,

  CREATE_DEPENDENT: DEPENDENTS_V2,
  DEACTIVATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/deactivate`,
  ACTIVATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/reactivate`,
  UPDATE_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}`,
  GET_DEPENDENTS_BY_EMPLOYEE_ID: (employeeId?: string | number) => `${DEPENDENTS_V2}/employee/${employeeId}`,
  ADD_CARD_FOR_DEPENDENT: (dependentId?: string) => `${DEPENDENTS_V2}/${dependentId}/add-card`,

  CIP_DOCUMENT_SCAN_CHECK: () => '/idology/document-process-status',
  DISTRIBUTORS: '/distributors',
  DOCUMENT_BY_ID: (documentId: string) => `/documents/${documentId}/files`,
  DOCUMENT_FILES: '/documents/files',
  ELECTRONIC_FUNDING_REPLENISHMENTS: `${ENUM}/electronic-funding-replenishments`,
  ELIGIBLE_DEPENDETS_TYPES: `${ENUM}/eligible-dependents`,
  RETRY_PAYMENT: '/claims/retry-payment',
  GET_REJECTED_CLAIM: (claimId?: string) => `${CLAIMS}/${claimId}/rejected-claim`,

  GET_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/beneficiaries`,
  CREATE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/beneficiaries`,
  UPDATE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/beneficiaries`,
  DELETE_BENEFICIARIES: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/beneficiaries`,
  GET_BENEFICIARY_TYPES: '/enums/beneficiary-relationship-types',

  GET_PROVIDERS: '/providers',
  GET_PROVIDER: (id: string) => `/providers/${id}`,
  EMPLOYEE_PERSONAL_INFO_BY_ID: (id: string) => `${EMPLOYEES}/personal-info/${id}`,
  EMPLOYEES_SEARCH: `${EMPLOYEES}/admin/search`,
  GET_EMPLOYEES_WITH_ACTIVE_PLANS: '/employee-search/active-plan',
  EMPLOYER: '/employer',
  EMPLOYERS: '/employers',
  ENCRYPTION_PUBLIC_KEY: 'encryption/public-key',

  ENROLLMENTS: 'enrollments/',
  ENROLLMENT_MATRIXES: '/enrollment-matrixes',
  ENROLLMENT_MATRIXES_CLOSEST: '/enrollment-matrixes/closest',
  ELIGIBLE_SERVICES: `${CATEGORIES}${SERVICES}`,
  GET_ELIGIBLE_PLAN_SERVICES_BY_ID: (id?: string) => `${PLANS}/${id}${SERVICES}`,
  EMPLOYEE_BY_ID: (id: string) => `${UI}/employees/${id}`,
  EMPLOYEE_BY_ID_EXTENDED: (id?: string) => `${UI}/employees/${id}/extended`,
  GET_SSN_BY_EMPLOYEE_ID: (id: string) => `${UI}/employees/${id}/ssn`,
  LOCK_EMPLOYEE_LOGIN: 'login/lock',
  UNLOCK_EMPLOYEE_LOGIN: 'login/unlock',
  EXPIRED_ENROLLMENT_MATRIXES: '/enrollment-matrixes/expired',
  EXPENSES_STATISTICS: '/expenses/statistics',
  ENROLLMENTS_EXPENSES_STATISTICS: '/enrollment/balance/expense',
  EXPENSES: '/expenses',

  EXPRESS_SETUPS,
  EXPRESS_SETUP_BY_ID: (id: string) => `${EXPRESS_SETUPS}/${id}`,
  EXPRESS_SETUP_STATUS_BY_ID: (id: string) => `${EXPRESS_SETUPS}/${id}/status`,
  GET_EXPRESS_SETUP_ORGANIZATION_PROPERTIES: '/express-setup/enabled',
  CREATE_EXPRESS_SETUP_CONTACT: 'express-setup/contacts',
  FILE_PROCESSOR_STREAM: '/file-status-event/stream',
  FISERV_TOKEN: '/tokens',
  FORGOT_PASSWORD: '/forgot-password',
  CHANGE_PASSWORD: '/passwords',
  RESET_PASSWORD: 'passwords/reset',
  FORGOT_USERNAME: `${CONTACTS}/usernames/forgot`,
  GET_BANK_BY_NAME: '/get-bank-by-name',
  GET_CLAIM_APPROVAL_STATUS_CODES: `${ENUM}/claim-approval-status-code`,

  GET_ORGANIZATION_BY_ID: (id?: string | null) => `${ORGANIZATIONS}/${id}`,
  GET_ORGANIZATION_PROPERTIES_FIELD_STATE: '/organization-properties-states',
  GET_FILE_DETAILS_BY_ID: (id: string) => `${FILE}/${id}`,
  GET_FILE_ACTORS: `${FILES}/file-actors`,
  GET_FILE_DETAILS: (id: string) => `${FILE}/files/${id}/details`,
  GET_FILE_DOWNLOAD_LINK: (id: string) => `${FILE}/file-link/${id}`,
  GET_FILE_ERRORS_CSV: (fileId: string) => `${FILE}/files/${fileId}/errors-csv`,
  GET_FILE_RECORD_ERRORS: (fileId: string) => `${FILE}/files/${fileId}/records/errors`,
  GET_FILE_ERRORS: (fileId: string) => `${FILE}/files/${fileId}/errors`,
  GET_FILES_BY_DOCUMENT_ID: (documentId?: string) => `/documents/${documentId}/files`,
  GET_FILES: `${FILE}/files`,
  GET_STATEMENTS: '/statements',
  GET_ORGANIZATION_NAME: (id?: string) => `${ORGANIZATIONS}/${id}/name`,
  GET_ORGANIZATION_LOCK_STATUS: (id?: string) => `/organization-locks/${id}`,
  GET_ORGANIZATION_SHORT_INFO: (id: string) => `${ORGANIZATIONS}/${id}/short`,
  GET_PLAN_YEARS: (id: string | null) => `${PLAN_YEARS}?organization_id=${id}`,
  GET_POLICIES_STATUSES: (id?: string) => `/policies/${id}/policy-statuses`,
  GET_EXISTING_POLICIES: '/policies',
  GET_EXISTING_ACCOUNTS: '/accounts/batch',
  MARK_EMPLOYEE_AS_BAD_DATA: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/bad-data`,
  GET_STATE: (name: string) => `${ENUM}/states&name=${name}`,
  GET_SUBSIDIARIES: '/subsidiary',
  GET_PAYOUT_DEFINITION_BY_ID: (id?: string) => `${PAYOUT_DEFINITION}/${id}`,
  GET_INVESTORS: '/investors',
  GET_ORGANIZATIONS_SHORT: '/organizations/short',
  GET_PLAN_ELECTION_AMOUNT: (id?: string) => `${PLANS}/${id}/election-amount`,
  GET_PLAN_ACCOUNT: `${PLANS}/accounts`,
  HELP: '/help',
  HOME: '/',
  HSA_CUSTODIAN: `${ENUM}/hsa-custodians`,
  INTEREST_RATE_ACTIVE: `${INTEREST_RATE}/active`,
  INTEREST_RATE_LATEST_VERSION: (id: string) => `${INTEREST_RATE}/${id}/versions/latest`,
  INTEREST_RATE,
  IRS_MAXIMUM: '/irs-maximums',
  IRS_MAXIMUM_TYPES: '/irs-maximums/types',
  GET_INVOICES_DASHBOARD: '/invoices/dashboard',
  GET_PREFUND_INVOICE: (id: string) => `/invoices/${id}/details-view`,
  REPULL_PREFUND_BY_INVOICE_ID: (id: string) => `/prefund-histories/invoices/${id}/repull`,
  REPULL_REPLENISHMENT_BY_INVOICE_ID: (id: string) =>
    `/prefund-histories/invoices/${id}/resume/replenishment/reject`,
  LOGIN: `${AUTH}login`,
  LOGIN_HISTORY_ADMIN: 'login-history/admin',
  LOGIN_HISTORY_EMPLOYEE: 'login-history/employee',
  SEND_FORGOT_PASSWORD_CODE: '/forgot-password',
  LOCK_ORGANIZATION: (id: string) => `/organization-locks/lock/${id}`,
  UNLOCK_ORGANIZATION: (id: string) => `/organization-locks/unlock/${id}`,
  ORGANIZATION_HIERARCHY: (organizationId: string) => `/hierarchy/${organizationId}`,
  ORGANIZATIONS,
  ORPHAN_ORGANIZATIONS: `${ORGANIZATIONS}/orphan`,
  ORGANIZATION_LOGO_EMAIL: '/organizations/logo/email-templates',
  ORGANIZATION_INFO: (organizationId?: string) => `${ORGANIZATIONS}/${organizationId}/employee-view`,
  EMPLOYEE_INFO: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/employee-view`,
  ORGANIZATION_PROPERTIES: (organizationId?: string) =>
    `${ORGANIZATIONS}/${organizationId}/overridable-properties/employee`,
  PARTNERS: '/partners',
  PAYMENT_METHODS: '/payment-methods',
  PAYOUT_DEFINITION,

  RENEWALS,
  RENEWALS_SETUP_BY_PLAN_YEAR_ID: (id: string) => `${RENEWALS}/plan-year/${id}`,

  PAYOUT_DEFINITION_PLANS: (id: string) => `${PAYOUT_DEFINITION}/${id}/plans`,
  PAYMENT_METHODS_ATTACH_CARD: (paymentId: string) => `/payment-methods/${paymentId}/card`,
  PAYMENT_RULE_ACCOUNTS: (id: string) => `/payout-definitions/${id}/plans`,
  PROCESSING_RULES: '/processing-rules',
  PROCESSING_RULE_BY_ID: (id?: string) => `/processing-rules/${id}`,
  PERSON_COPAY_GROUPS: '/copay-groups',
  PERSON_ORGANIZATIONS_CONTACTS: `${CONTACTS}/all`,
  PERSON_ORGANIZATIONS_HIERARCHY_BY_ID: `${CONTACTS}/up-hierarchy`,
  PLAN_BY_ID: (id: string) => `${PLANS}/${id}`,
  PLAN_YEAR: (id?: string) => `${PLAN_YEARS}/${id || ''}`,
  PLANS_BY_PLAN_YEAR: (id?: string) => `${PLAN_YEARS}/${id || ''}${PLANS}`,
  PRIOR_PLAN_YEAR: `${PLAN_YEARS}${PRIORS}`,
  GET_LINKED_EMPLOYEES: (employeeId?: string) => `${EMPLOYEES}/${employeeId}/link`,
  GET_LINKED_ACCOUNTS: `${EMPLOYEES}/linkage-search`,
  GET_PLAN_YEARS_LIST: `${PLAN_YEARS}/list`,
  GET_ORG_NOTES_BY_ID: (id?: string) => `${ORGANIZATIONS}/${id}/notes`,
  GET_PLAN_NOTES_BY_ID: (id?: string) => `${PLANS}/${id}/notes`,
  GET_HEALTH_PLAN_NOTES_BY_ID: (id?: string) => `${HEALTH_PLANS}/${id}/notes`,
  PLAN_PRIOR: `${PLANS}${PRIORS}`,
  PLANS,
  PLANS_CODES_VALIDATOR: `${PLANS}/plan-codes/validations`,
  HEALTH_PLANS,
  HEALTH_PLAN_TEMPLATES: `${HEALTH_PLANS}/templates`,
  HEALTH_PLAN_BY_ID: (id: string) => `${HEALTH_PLANS}/${id}`,
  HEALTH_PLAN_YEARS: `${PLAN_YEARS}${HEALTH_PLANS}`,
  PROCESS_FILE: (fileId: string) => `/file/approve/${fileId}`,
  FILE_CANCEL: (fileId: string) => `/file/cancel/${fileId}`,
  FILE_REMOVE: (fileId: string) => `/file/files/${fileId}`,
  FILE_PROCESS_DUPLICATE: (fileId: string) => `${FILE}/process-duplicate/${fileId}`,
  PROOF_EXPENSES_TYPES: `${ENUM}/proof-of-expenses`,

  RELATIONSHIP_LIST: `${ENUM}/relationship-types`,
  REPLACEMENT_CARD_REQUEST: (cardId: string) => `/cards/${cardId}/replacement`,

  ROLES: '/roles',
  ROLES_SEARCH: '/roles',
  ROLES_ALLOWED_TO_CREATION: '/roles/user-and-organization',
  ROLES_ALLOWED_TO_CREATION_BY_ID: (id: string) => `/roles/${id}/allow-for-creation`,
  ROLE_BY_ID: (id: string) => `/roles/${id}`,
  UPDATE_EMPLOYEE_ROLE: 'application-users/role',
  UNLOCK_EMPLOYEE_MFA: '/mfa/unlock',
  FIELD_LEVEL_ACCESS_LIST: '/organization-properties-state-configs',
  FIELD_LEVEL_ACCESS_BY_ID: (id: string) => `/organization-properties-state-configs/${id}`,

  PERMISSIONS_ALL: '/permissions/all',

  REIMBURSE_RECEIPT_UPLOAD: (documentId: string) => `/documents/${documentId}/import`,
  REIMBURSE_SCANNED_FILE: (fileId: string) => `/documents/files/${fileId}/ocr-reader`,
  CLAIM_SCANNED_FILE: (fileId: string) => `/documents/files/${fileId}/openai/ocr/matching`,
  SEND_CODE: '/send-code',
  SEND_VERIFICATION_CODE: '/codes/verifications',
  SEND_VERIFICATION_CODE_FOR_CONTACT: '/contacts/verification-codes',
  VERIFY_EMAIL_FOR_CONTACT: '/contacts/email/verifications',
  SERVICES_TYPE: (id: string, type?: string, categories?: string[]) =>
    `/payout-definitions/${id}/services?type=${type || ''}&categories=${categories || ''}`,
  SERVICE_CATEGORIES: `${ENUM}/service-categories`,
  SERVICE_CONFIGS: '/service-configs',
  SOURCE_IDS: `${ENUM}/source-ids`,
  SPEND_LIMIT_PERIODS: (id?: string) => `${SPEND_LIMIT_PERIODS}/${id}`,
  SPEND_LIMIT_PERIODS_REMAINING: (id?: string) => `${SPEND_LIMIT_PERIODS}/${id}/remaining`,
  STATES: `${ENUM}/states`,
  ATTRIBUTES_LIST: '/attributes-list',
  ACTIVITY_LOG: '/activity-logs',
  ACTIVITY_LOG_CHANGESET: (changesetId?: string) => `/activity-logs/${changesetId}`,
  ACTIVITY_LOG_CHANGESETS: '/activity-logs-map',
  SERVICES: '/services',
  ACCOUNT_ORDERS_SERVICES: '/account-orders/services',
  ACCOUNT_ORDERS_MATRIXES: '/account-orders/matrixes',
  TEMPLATES,
  GET_TAX_FORM_1099_FILE: (id: string) => `/tax-forms/tax-form-1099/${id}/download`,
  GET_TAX_FORM_5498_FILE: (id: string) => `/tax-forms/tax-form-5498/${id}/download`,
  GET_TAX_FORMS: '/v2/tax-forms',
  LINKED_TEMPLATES: (orgId?: string) => `${TEMPLATES}${ORGANIZATIONS}/${orgId}${LINKED_TEMPLATES}`,
  EMAIL_ILLUSTRATION: '/email-illustrations',
  EMAIL_THEMES: '/email-template-themes',
  MOBILE_APP_THEMES: '/mobile-themes',
  TEMPLATE_ASSIGNED: `${PLANS}/template-assigned`,
  EMPLOYER_TERMINATION_PLANS: (orgId: string) => `${PLANS}${ORGANIZATIONS}/${orgId}/active-grace-period`,
  PLAN_TERMINATION_DATA: (planId?: string) => `${PLANS}/${planId}/active-grace-period`,
  ORG_PLANS_TERMINATION_DATA: `${PLANS}/termination-properties`,
  TRIGGERS: `${ENUM}/triggers`,
  TRANSACTOR_DETAILS_BY_ID: (id?: string) => `/transactors/${id}`,
  UPDATE_INTERNAL_NOTE: (claimId: number, noteId: number) => `${CLAIMS}/${claimId}/internal-notes/${noteId}`,
  UPDATE_CLAIM_NOTE: (claimId?: string) => `${CLAIMS}/${claimId}/escalation-note`,
  UPLOAD_CSV_FILE: '/files/csv/import',
  UPLOAD_ORGANIZATION_LOGO: `${ORGANIZATIONS}/logo`,
  UPDATE_DEFAULT_PAYMENT_METHODS: (paymentMethodId: number | string) => `/payment-methods/${paymentMethodId}`,
  UNLINK_TEMPLATE: (id?: string, orgId?: string) => `/templates/${id}/unlinking?organization_id=${orgId}`,
  GET_EXTERNAL_EMAIL_TEMPLATES: '/external-templates',
  GET_AVAILABLE_EXTERNAL_EMAIL_TEMPLATES: '/external-templates/available',
  GET_HTML_PREVIEW_EMAIL_TEMPLATES: (id?: string) => `/external-templates/${id}/html-preview`,
  GET_HTML_PREVIEW_VARIABLES_EMAIL_TEMPLATES: (id?: string) => `/external-templates/${id}/variables`,
  UPDATE_EXTERNAL_EMAIL_TEMPLATE: (id?: string) => `/organizations/${id}/notification-properties`,
  CREATE_ENROLLMENT: '/enrollments',
  CREATE_HEALTH_PLAN_ENROLLMENT: '/health-plans-enrollments',
  FISERV_CARD_ACTIVATION: '/maintenance/card',
  ORG_PREFUND_HISTORIES: (invoiceId: string) => `/prefund-histories/invoices/${invoiceId}/summary`,
  GET_PREFUND_RETURN_STATUS: (invoiceId: string) => `/prefund-returns/invoices/${invoiceId}`,
  APPROVE_PREFUND_RETURN_STATUS: '/prefund-returns/approve',
  CARD_ACTIVITY: '/activities/cards',
  CLAIMS_ACTIVITIES: `${CLAIMS}/search/activities`,
  PROCESS_WAITING_FOR_FUNDS_CLAIM: (id?: string) => `${CLAIMS}/${id}/process-waiting-for-funds`,
  ACCOUNT_NUMBER: (accountId: string) => `/accounts/hsa/${accountId}/number`,
  INTERNAL_ACCOUNT_NUMBER: (accountId: string) => `/accounts/internal/${accountId}/number`,
  UPDATE_CLAIM_DOCUMENT_ID: (id?: string) => `${CLAIMS}/${id}/document`,
  ESCALATE_CLAIM: (id?: string) => `/claims/claim/${id}/escalate`,
  LOCKBOXES: '/lockboxes',
  LOCKBOX_BY_ID: (lockboxId?: string) => `/lockboxes/${lockboxId}`,
  UPDATE_LOCKBOX: (lockboxId?: string) => `/lockboxes/${lockboxId}`,
  UPDATE_LOCKBOX_CHECK_DETAILS: (lockboxId?: string) => `/lockboxes/${lockboxId}/check-details`,
  GET_MATCHED_EMPLOYEES: `${EMPLOYEES}/matches`,
  GET_MATCHED_EMPLOYEE_BY_ID: (employeeId?: string) => `/lockboxes/matched-employees/${employeeId}`,
  GET_CLAIMS_REPAYMENT_MATCHES: `${CLAIMS}/repayment/matches`,
  GET_CLAIM_RELATED_CARD_SWIPES: (claimId?: string) => `${CLAIMS}/${claimId}/related-card-swipes`,
  LOCKBOXES_SPLITTING: (lockboxId?: string) => `/lockboxes/${lockboxId}/splitting`,
  GET_CONTRIBUTION_SEGMENT_BY_ID: (contributionId?: string) => `/segments?contribution_id=${contributionId}`,
  CREATE_MANUAL_CONTRIBUTION: (contributionDate?: string) =>
    `/manual-contribution?contribution_date=${contributionDate}`,

  STATISTIC_SUBSTANTIATION_RATE: '/metrics/claims-substantiation-rate',
  STATISTIC_ENROLLMENT: '/metrics/plan-enrollment',

  STATISTIC_EMPLOYEES: '/metrics/employees',
  STATISTIC_CIP_CONFIG: '/metrics/cip-config',
  STATISTIC_CIP: '/metrics/cip-info',
  STATISTIC_REPLENISHMENT: '/metrics/invoice-replenishment',
  STATISTIC_REPLENISHMENT_PLAN: '/metrics/invoice-plan-level-replenishment',

  GET_CONTRIBUTION_ACTIVITIES: '/contributions/contribution-requests/activity',
  GET_CONTRIBUTION_ERRORS_BY_REQUEST_ID: (requestId?: string) =>
    `/contributions/contribution-requests/${requestId}/error-records-count`,
  UPDATE_ALL_CONTRIBUTION_RECORDS_SAME_VALUES: (requestId?: string) =>
    `/contributions/contribution-requests/${requestId}/contribution-records/update-all`,
  DELETE_CONTRIBUTION_RECORDS: (requestId?: string) =>
    `/contributions/contribution-requests/${requestId}/contribution-records`,
  UPDATE_CONTRIBUTION_RECORDS: (requestId?: string) =>
    `/contributions/contribution-requests/${requestId}/contribution-records`,
  GET_CONTRIBUTION_REQUEST_RECORDS: (contributionRequestId?: string) =>
    `/contributions/contribution-requests/${contributionRequestId}`,
  GET_CONTRIBUTION_ACTIVITIES_CSV_REPORT: '/contributions/contribution-requests/activity/csv-report',
  GET_CONTRIBUTIONS: '/contribution-requests',
  GET_TRANSACTIONS_INFO: '/transactions',
  GET_ACCOUNTS_CLOSURE_AMOUNTS: '/accounts/closure-amounts',
  GET_CONTRIBUTIONS_EMPLOYEE_VIEW: '/manual-contribution/employees',
  GET_MANUAL_CONTRIBUTION_COVERAGE_PERIOD: '/manual-contribution/coverage-periods',
  GET_TOTAL_CONTRIBUTIONS_EMPLOYEE_VIEW: '/manual-contribution/employees/count',
  GET_PAYROLL_GROUPS: (orgId?: string) => `/payroll-groups/organizations/${orgId}`,
  GET_PAYROLL_CALENDARS: (orgId?: string) => `/ui/payroll-calendars/organizations/${orgId}`,
  GET_ACTIVE_PAYROLL_CALENDARS: '/payroll-calendars/organizations/organization-path/reduced',
  CREATE_PAYROLL_GROUP: '/payroll-groups',
  UPDATE_PAYROLL_GROUP: (id?: string) => `/payroll-groups/${id}`,
  START_CLAIM_REPAYMENT: (claimId?: string) => `${CLAIMS}/${claimId}/start-repayment`,

  ORGANIZATION_PAYROLL_CALENDAR: (id?: string) => `/payroll-calendars/organizations/${id}`,
  CONTRIBUTION_RECORDS: '/contribution/records',
  SCHEDULED_CONTRIBUTION_CALENDAR_SUMMARY: (id: string) =>
    `/scheduled-contribution-search/calendar/${id}/summary`,
  SCHEDULED_CONTRIBUTION_RECORDS_SUMMARY: (id: string) =>
    `/scheduled-contribution-search/calendar/${id}/employees`,
  SCHEDULED_CONTRIBUTION_EXPORT: (id: string) => `/scheduled-contribution-search/calendar/${id}/csv-report`,

  GET_CLAIM_TRANSFERS_AMOUNT_BY_CLAIM_ID: (claimId?: string) => `${CLAIMS}/${claimId}/transfer/calculate`,
  TRANSFERS_CLAIM: (claimId?: string) => `/transfer/claims/${claimId}`,

  TRANSFER_AMOUNT_AVAILABLE: (claimId?: string, accountFromId?: string) =>
    `${CLAIMS}/${claimId}/transfer-amount-available/${accountFromId}`,

  SCHEDULED_CONTRIBUTION: '/scheduled-contributions',
  SCHEDULED_CONTRIBUTION_ORGANIZATION: '/scheduled-contribution-search/organization',
  CONTRIBUTION_HISTORY: '/monitor-contribution/info',
  CALCULATE_PAYROLL_CALENDAR_SCHEDULE: '/payroll-calendars/calculate-schedule',
  PAYROLL_CALENDARS: '/payroll-calendars',
  UPDATE_OR_DELETE_PAYROLL_CALENDAR: (id?: string) => `/payroll-calendars/${id}`,
  GET_PAYROLL_CALENDAR_BY_ID: (id?: string) => `/ui/payroll-calendars/${id}`,
  GET_VENDORS: '/vendors',
  GET_IS_PLAN_LEVEL_FUNDING_ENABLED: '/plan-account-funding-config/plan-level-funding/organizations',
  GET_EMPLOYEE_ACCOUNTS: (employeeId?: string) => `/transfer${EMPLOYEES}/${employeeId}/accounts`,
  LETTERS_OF_MEDICAL_NECESSITY: '/letters-of-medical-necessity',
  CREATE_LETTERS_OF_MEDICAL_NECESSITY: '/letters-of-medical-necessity',
  LETTERS_OF_MEDICAL_NECESSITY_BY_ID: (id?: string) => `/letters-of-medical-necessity/${id}`,
  CLAIMS_SEARCH_PARTICIPANT: `/claims/search`,
  RECEIPTS: '/documents/receipts/files',

  SIGN_IN: 'contacts/signin',
  REVOKE: '/revoke',
  SEND_EXPRESS_SETUP_CODE: 'contacts/codes',
  VERIFY_EXPRESS_SETUP_CODE: 'contacts/codes/verifications',
  SEND_MFA_CODE: 'contacts/mfa/codes',
  VERIFY_MFA_CODE: 'contacts/mfa/codes/verifications',

  FEE_REVERSAL: '/fee/reversal',
  FEE_TRANSFER: '/fee/transfer',

  FIND_ORGANIZATIONS_BY_ACCOUNT_MANAGER_ID: (accountManagerId?: string) =>
    `${ORGANIZATIONS}/account-manager/${accountManagerId}`,
  UNASSIGN_ALL_ACCOUNT_MANAGER_ROLES: (contactId?: string) =>
    `${CONTACTS}/${contactId}/unassign-account-manager`,

  CREATE_FILE_UPLOAD_URL: (documentId: string) => `/documents/${documentId}/files/link`,
  COMPLETE_FILE_UPLOAD: (documentId: string) => `/documents/${documentId}/files/link/complete`,

  GET_REACTIVATION_ELIGIBLE_PLANS: (orgId?: string) => `/plans/organizations/${orgId}/reactivation-eligible`,
  REACTIVATE_EMPLOYER: (orgId?: string) => `organizations/${orgId}/reactivation`,
};
